export default __webpack_public_path__ + "static/ie-df007250628545adc580b06c49102271.svg";